import { defineMobileFormWindow } from "@app/overlay";
import {
    WsDepotCardsFilterForm,
    type WsDepotCardsFilterFormProps,
} from "./components/WsDepotCardsFilter/WsDepotCardsFilterForm";

/** Реестр overlay-окон списка цеховой номенклатуры. */
export const wsDepotCardsListWindows = {
    filter: defineMobileFormWindow<WsDepotCardsFilterFormProps>({
        key: "workshop.depotCards.filter",
        title: "Фильтр цех. номенклатуры",
        component: WsDepotCardsFilterForm,
    }),
};
